import { render, staticRenderFns } from "./data60.vue?vue&type=template&id=734b6584&scoped=true"
import script from "./data60.vue?vue&type=script&lang=js"
export * from "./data60.vue?vue&type=script&lang=js"
import style1 from "./data60.vue?vue&type=style&index=1&id=734b6584&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734b6584",
  null
  
)

export default component.exports